(() => {
  function initialize(dialog) {
    if (dialog.dataset.searchReady) return;
    dialog.dataset.searchReady = 'true';
    const form = dialog.querySelector('[data-search-form]');
    const input = dialog.querySelector('[data-search-input]');
    const results = dialog.querySelector('[data-search-results]');
    const status = dialog.querySelector('[data-search-status]');
    const viewAll = dialog.querySelector('[data-search-view-all]');
    const hint = status.textContent;
    let timer;
    let request;
    let revision = 0;
    let savedOverflow;

    function reset() {
      clearTimeout(timer);
      request?.abort();
      revision++;
      results.replaceChildren();
      results.removeAttribute('aria-busy');
      viewAll.hidden = true;
      status.textContent = hint;
    }

    async function search(query, version) {
      request = new AbortController();
      const activeRequest = request;
      results.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.loading;
      try {
        const url = new URL(form.action, location.origin);
        url.pathname = `${url.pathname.replace(/\/$/, '')}/suggest`;
        url.search = new URLSearchParams({
          q: query,
          'resources[type]': 'product,article,page',
          // Match titles/types/tags only (not body copy, which flooded
          // results with the whole catalog) and never suggest unavailable
          // products. Liquid then ranks title matches first and applies
          // the gift/test exclusions, so ask for the max (10) per type.
          'resources[options][fields]': 'title,product_type,tag,vendor',
          'resources[options][unavailable_products]': 'hide',
          'resources[limit]': '10',
          'resources[limit_scope]': 'each',
          section_id: 'tnm-predictive-search',
        });
        const response = await fetch(url, { signal: activeRequest.signal });
        if (!response.ok) throw new Error(`Search returned ${response.status}`);
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('[data-tnm-predictive-results]');
        if (!content) throw new Error('Search response is missing results');
        if (version !== revision || input.value.trim() !== query || !dialog.open) return;
        results.replaceChildren(content);
        status.textContent = content.dataset.status;
        viewAll.hidden = false;
      } catch (error) {
        if (error.name === 'AbortError' || version !== revision) return;
        results.replaceChildren();
        status.textContent = status.dataset.error;
        viewAll.hidden = false;
      } finally {
        if (version === revision) results.removeAttribute('aria-busy');
      }
    }

    input.addEventListener('input', () => {
      reset();
      const query = input.value.trim();
      if (!query) return;
      const version = revision;
      timer = setTimeout(() => search(query, version), 250);
    });
    form.addEventListener('submit', (event) => {
      if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
      }
    });
    dialog.querySelector('[data-search-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        dialog.close();
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      reset();
      input.value = '';
      if (savedOverflow !== undefined) {
        document.documentElement.style.overflow = savedOverflow;
        savedOverflow = undefined;
      }
    });
    new MutationObserver(() => {
      if (dialog.open) {
        if (savedOverflow === undefined) savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        input.focus();
      }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('keydown', (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        if (dialog.open) dialog.close();
        else dialog.showModal();
      }
    });
  }

  document.querySelectorAll('[data-tnm-search-dialog]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tnm-search-dialog]').forEach(initialize);
  });
})();
